// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1929":"0780253b","4011":"edf771da","4320":"0780253b","4918":"c1794862","5907":"9c79af65","8777":"fe58350d"}[chunkId] + ".chunk.css";
};